// Main translation index file that imports all translation files
// This file serves as the central point for all translations

import en from './en';
import id from './id';

const translations = {
  en,
  id
};

export default translations;